const compatModules = {};import * as Mod1 from "./discourse/components/ad-component";
compatModules["discourse/components/ad-component"] = Mod1;

export * as discourse$components$ad__component$$__module from "./discourse/components/ad-component";
export {
default as discourse$components$ad__component$$default
} from "./discourse/components/ad-component";
import * as Mod2 from "./discourse/components/ad-slot";
compatModules["discourse/components/ad-slot"] = Mod2;

export * as discourse$components$ad__slot$$__module from "./discourse/components/ad-slot";
export {
slotContenders as discourse$components$ad__slot$$slotContenders,
default as discourse$components$ad__slot$$default
} from "./discourse/components/ad-slot";
import * as Mod3 from "./discourse/components/adbutler-ad";
compatModules["discourse/components/adbutler-ad"] = Mod3;

export * as discourse$components$adbutler__ad$$__module from "./discourse/components/adbutler-ad";
export {
default as discourse$components$adbutler__ad$$default
} from "./discourse/components/adbutler-ad";
import * as Mod4 from "./discourse/components/amazon-product-links";
compatModules["discourse/components/amazon-product-links"] = Mod4;

export * as discourse$components$amazon__product__links$$__module from "./discourse/components/amazon-product-links";
export {
default as discourse$components$amazon__product__links$$default
} from "./discourse/components/amazon-product-links";
import * as Mod5 from "./discourse/components/carbonads-ad";
compatModules["discourse/components/carbonads-ad"] = Mod5;

export * as discourse$components$carbonads__ad$$__module from "./discourse/components/carbonads-ad";
export {
default as discourse$components$carbonads__ad$$default
} from "./discourse/components/carbonads-ad";
import * as Mod6 from "./discourse/components/google-adsense";
compatModules["discourse/components/google-adsense"] = Mod6;

export * as discourse$components$google__adsense$$__module from "./discourse/components/google-adsense";
export {
default as discourse$components$google__adsense$$default
} from "./discourse/components/google-adsense";
import * as Mod7 from "./discourse/components/google-dfp-ad";
compatModules["discourse/components/google-dfp-ad"] = Mod7;

export * as discourse$components$google__dfp__ad$$__module from "./discourse/components/google-dfp-ad";
export {
default as discourse$components$google__dfp__ad$$default
} from "./discourse/components/google-dfp-ad";
import * as Mod8 from "./discourse/components/house-ad";
compatModules["discourse/components/house-ad"] = Mod8;

export * as discourse$components$house__ad$$__module from "./discourse/components/house-ad";
export {
default as discourse$components$house__ad$$default
} from "./discourse/components/house-ad";
import * as Mod9 from "./discourse/components/post-bottom-ad";
compatModules["discourse/components/post-bottom-ad"] = Mod9;

export * as discourse$components$post__bottom__ad$$__module from "./discourse/components/post-bottom-ad";
export {
default as discourse$components$post__bottom__ad$$default
} from "./discourse/components/post-bottom-ad";
import * as Mod10 from "./discourse/connectors/after-topic-list-item/discourse-adplugin.gjs";
compatModules["discourse/connectors/after-topic-list-item/discourse-adplugin"] = Mod10;

export * as discourse$connectors$after__topic__list__item$discourse__adplugin$$__module from "./discourse/connectors/after-topic-list-item/discourse-adplugin.gjs";
export {
default as discourse$connectors$after__topic__list__item$discourse__adplugin$$default
} from "./discourse/connectors/after-topic-list-item/discourse-adplugin.gjs";
import * as Mod11 from "./discourse/connectors/discovery-list-container-top/discourse-adplugin.gjs";
compatModules["discourse/connectors/discovery-list-container-top/discourse-adplugin"] = Mod11;

export * as discourse$connectors$discovery__list__container__top$discourse__adplugin$$__module from "./discourse/connectors/discovery-list-container-top/discourse-adplugin.gjs";
export {
default as discourse$connectors$discovery__list__container__top$discourse__adplugin$$default
} from "./discourse/connectors/discovery-list-container-top/discourse-adplugin.gjs";
import * as Mod12 from "./discourse/connectors/topic-above-post-stream/discourse-adplugin.gjs";
compatModules["discourse/connectors/topic-above-post-stream/discourse-adplugin"] = Mod12;

export * as discourse$connectors$topic__above__post__stream$discourse__adplugin$$__module from "./discourse/connectors/topic-above-post-stream/discourse-adplugin.gjs";
export {
default as discourse$connectors$topic__above__post__stream$discourse__adplugin$$default
} from "./discourse/connectors/topic-above-post-stream/discourse-adplugin.gjs";
import * as Mod13 from "./discourse/connectors/topic-above-suggested/discourse-adplugin.gjs";
compatModules["discourse/connectors/topic-above-suggested/discourse-adplugin"] = Mod13;

export * as discourse$connectors$topic__above__suggested$discourse__adplugin$$__module from "./discourse/connectors/topic-above-suggested/discourse-adplugin.gjs";
export {
default as discourse$connectors$topic__above__suggested$discourse__adplugin$$default
} from "./discourse/connectors/topic-above-suggested/discourse-adplugin.gjs";
import * as Mod14 from "./discourse/helpers/slot-position";
compatModules["discourse/helpers/slot-position"] = Mod14;

export * as discourse$helpers$slot__position$$__module from "./discourse/helpers/slot-position";
export {
isNthPost as discourse$helpers$slot__position$$isNthPost,
isNthTopicListItem as discourse$helpers$slot__position$$isNthTopicListItem
} from "./discourse/helpers/slot-position";
import * as Mod15 from "./discourse/initializers/adplugin-admin-plugin-configuration-nav";
compatModules["discourse/initializers/adplugin-admin-plugin-configuration-nav"] = Mod15;

export * as discourse$initializers$adplugin__admin__plugin__configuration__nav$$__module from "./discourse/initializers/adplugin-admin-plugin-configuration-nav";
export {
default as discourse$initializers$adplugin__admin__plugin__configuration__nav$$default
} from "./discourse/initializers/adplugin-admin-plugin-configuration-nav";
import * as Mod16 from "./discourse/initializers/initialize-ad-plugin";
compatModules["discourse/initializers/initialize-ad-plugin"] = Mod16;

export * as discourse$initializers$initialize__ad__plugin$$__module from "./discourse/initializers/initialize-ad-plugin";
export {
default as discourse$initializers$initialize__ad__plugin$$default
} from "./discourse/initializers/initialize-ad-plugin";
export default compatModules;
